import qs from 'qs'

export async function postUrl(url = '', data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer', // no-referrer, *client
    body: qs.stringify(data)  // body data type must match "Content-Type" header (e.g. JSON.stringify(data)) if 'Content-Type': 'application/json'
  });
  return await response.text() // parses JSON response into native JavaScript objects
}

export async function getUrl(url = '', data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'text/html'
    },
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer', // no-referrer, *client
  });
  return await response.text() // parses JSON response into native JavaScript objects
}

export const isTagNode = node => node.type === 'tag';

/**
 * Used for detecting existing modified form actions or prepending the host in situations where
 * we want to follow the standard redirect whilst submitting a form.
 */
export const legacyHost = 'https://www.rainedout.net/';

/**
 * Purge form markup of specific wrapping elements.
 * @param {*} node DOMNode being processed
 * @param {*} index Element Index provided by convertNodeToElement
 */
export const cleanRequestResponse = node => {
  const isTag = isTagNode(node);
  const isHiddenElementId = id => ['left', 'right', 'search_area', 'search', 'logo', 'lower'].indexOf(id) !== -1;
  const isHiddenElementClass = className => ['accessible', 'title', 'tabs'].indexOf(className) !== -1;
  const isHiddenElementTag = nodeName => ['meta', 'title'].indexOf(nodeName) !== -1;
  const isFormActionRequiringPrefix = action => ['create_new_account.php'].indexOf(action) !== -1 && action.indexOf(legacyHost) === -1;

  if (isTag && node.name === 'html') {
    // Remove all xmls validation tags and convert to div
    node.name = 'div';
    node.attribs = {};
    return node;
  } else if (isTag && node.name === 'head') {
    // Convert to div
    node.name = 'div';
    return node;
  } else if (isTag && node.name === 'body') {
    // Convert to div
    node.name = 'div';
    return node;
  } else if (isTag && node.name === 'link') {
    // Remove all style tags and convert to div
    node.name = 'div';
    node.attribs = {};
    return node;
  } else if (isTag && node.name === 'p') {
    node.name = 'div';
    return node;
  } else if (isTag && node.name === 'form' && isFormActionRequiringPrefix(node.attribs.action)) {
    node.attribs.action = legacyHost + node.attribs.action
    return node;
  } else if (isTag && (isHiddenElementTag(node.name) || isHiddenElementId(node.attribs.id) || isHiddenElementClass(node.attribs.class))) {
    return null;
  }
}

/**
 * Append `index.html` in production to our redirect URLs.  Production build of gatsby requires this extension.
 * @param {*} url 
 */
export const redirectUrl = url => process.env.GATSBY_ENV === 'production' ? url + '/index.html' : url;